import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import axios from "axios";

const Char = ({ character, favs, setFavs, token, favIcon }) => {
  //Add to Favourite.. helper function
  const addFav = async () => {
    if (!token) {
      console.log(
        "No logged user found..Please log in before adding favourites"
      );
    } else {
      const newFavs = { ...favs };
      newFavs.persons.push(character._id);
      const reqData = { token: token, favs: newFavs };
      const response = await axios.post(
        `${process.env.REACT_APP_API}/user/addfav`,
        reqData
      );

      setFavs(newFavs);
    }
  };

  //Remov from Favourite.. helper function
  const removeFav = async () => {
    if (!token) {
      console.log(
        "No logged user found..Please log in before adding favourites"
      );
    } else {
      console.log(favs);
      const newFavs = { ...favs };
      const toRemove = newFavs.persons.indexOf(character._id);
      newFavs.persons.splice(toRemove, 1);
      const reqData = { token: token, favs: newFavs };
      const response = await axios.post(
        `${process.env.REACT_APP_API}/user/addfav`,
        reqData
      );
      console.log(response.data);
      setFavs(newFavs);
    }
  };

  return (
    <div className="char-card">
      <Link to={`/character/${character._id}`}>
        <div>
          <img
            className="comic-img"
            src={`${character.thumbnail.path}.${character.thumbnail.extension}`}
            alt=""
          />
        </div>
      </Link>

      <div className="comic-labels">
        <div>
          <p className="comic-title">{character.name}</p>
          <p className="comic-desc">{character.description}</p>
        </div>
        <div className={token ? "fav-pan" : "fav-pan hide"}>
          <FontAwesomeIcon
            onClick={removeFav}
            icon="heart"
            className={favIcon(favs, "persons", character) ? "" : "hide"}
          />
          <FontAwesomeIcon
            onClick={addFav}
            icon="plus-circle"
            className={favIcon(favs, "persons", character) ? "hide" : ""}
          />
        </div>
      </div>
    </div>
  );
};

export default Char;
